import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { SITE_CONFIG } from "@/data/siteConfig";

const NAV = [
  { to: "/shop", label: "Shop" },
  { to: "/projects", label: "Projects" },
  { to: "/visit", label: "Visit" },
  { to: "/about", label: "About" },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-cream border-b border-rule"
    >
      <div className="container-wide flex items-center justify-between h-20 md:h-24">
        <Link to="/" data-testid="header-logo" aria-label="Cactus Rose Needle Arts home">
          <img
            src={SITE_CONFIG.brand.logoTransparent}
            alt="Cactus Rose Needle Arts"
            className="h-[66px] md:h-[84px] w-auto"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8 lg:gap-10" data-testid="header-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `py-2 text-sm font-medium border-b transition-colors ${
                  isActive
                    ? "text-forest border-forest"
                    : "text-espresso border-transparent hover:text-clay"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          onClick={() => setMobileOpen((open) => !open)}
          className="md:hidden p-2 -mr-2 text-espresso"
          data-testid="header-mobile-menu-btn"
          aria-label={mobileOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileOpen}
        >
          {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden border-t border-rule bg-cream" data-testid="header-mobile-panel">
          <nav className="container-wide flex flex-col py-3">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-3 text-base font-medium border-b border-rule/70 last:border-0 ${
                    isActive ? "text-forest" : "text-espresso"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
